<template>
  <el-container id="tab">
    <el-aside :width="isCollapse ? '20px' : '230px'">
      <el-card v-show="!isCollapse" class="box-card">
        <div slot="header">
          <span>查询条件</span>
          <el-button style="float: right; padding: 3px 0" icon="el-icon-d-arrow-left" type="text"
            @click="isCollapse = !isCollapse"></el-button>
        </div>
        <el-form ref="queryFormRef" :model="queryForm" size="small">
          <el-scrollbar>
            <el-form-item label="日期" prop="billDate.selected">
              <date-picker class="query_form_item" style="width: 100%;" v-model="queryForm.billDate.selected"
                type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
              </date-picker>
            </el-form-item>
            <el-form-item label="客户大片区" prop="domainDesc.selected">
              <select-multiple class="query_form_item" :select-data="queryForm.domainDesc"></select-multiple>
            </el-form-item>
            <el-form-item label="客户小片区" prop="smallDomain.selected">
              <select-multiple class="query_form_item" :select-data="queryForm.smallDomain"></select-multiple>
            </el-form-item>
            <el-form-item label="客户类型" prop="customerTypes.selected">
              <select-multiple class="query_form_item" :select-data="queryForm.customerTypes"></select-multiple>
            </el-form-item>
            <el-form-item label="客户" prop="customer.selected">
              <el-select class="select_multiple query_form_item" ref="customerSelectRef"
                v-model="queryForm.customer.selected" value-key="value" multiple clearable placeholder="请选择客户名称"
                @click.native="customerInputFocus">
                <el-option v-for="item in queryForm.customer.list" :key="item.value" :label="item.text"
                  :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户标签" prop="label.selected">
              <el-select v-model="queryForm.label.selected" filterable multiple value-key="id" placeholder="请选择客户标签">
                <el-option v-for="item in queryForm.label.list" :key="item.id" :label="item.labelDesc" :value="item">
                  <span>{{ item.labelDesc }}({{ item.shortName }})</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="仓库" prop="inWarehouse.selected">
              <select-multiple class="query_form_item" :select-data="queryForm.inWarehouse"></select-multiple>
            </el-form-item>
            <el-form-item label="品牌" prop="financialBrand.selected">
              <select-multiple class="query_form_item" :select-data="queryForm.financialBrand"
                :isClear="false"></select-multiple>
            </el-form-item>
            <el-form-item label="大类" prop="brand.selected">
              <select-multiple class="query_form_item" :select-data="queryForm.brand"
                :change="brandChange"></select-multiple>
            </el-form-item>
            <el-form-item label="小类" prop="brandType.selected">
              <select-multiple class="query_form_item" :select-data="queryForm.brandType"></select-multiple>
            </el-form-item>
            <el-form-item label="商品" prop="product.selected">
              <el-select class="select_multiple query_form_item" ref="productSelectRef"
                v-model="queryForm.product.selected" value-key="value" multiple clearable placeholder="请选择商品名称"
                @click.native="productInputFocus">
                <el-option v-for="item in queryForm.product.list" :key="item.value" :label="item.text"
                  :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务员" prop="salesman.selected">
              <select-multiple class="query_form_item" :select-data="queryForm.salesman"></select-multiple>
            </el-form-item>
            <el-form-item style="text-align: center;" prop="isContainBack.selected">
              <el-checkbox v-model="queryForm.isContainBack.selected" true-label="Y" false-label="N"
                @change="onSubmit()">合计金额和数量包含还货单</el-checkbox>
            </el-form-item>
          </el-scrollbar>
          <el-form-item style="text-align: center;">
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <div class="is-collapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
        <span style="text-align: center;">查询</span>
        <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
        <span style="text-align: center;">条件</span>
      </div>
    </el-aside>
    <el-main>
      <div class="main-wrap">
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
          <el-tab-pane name="customer" label="客户销售排行"></el-tab-pane>
          <el-tab-pane name="salesman" label="业务员销售排行"></el-tab-pane>
          <el-tab-pane name="commodity" label="商品销售排行"></el-tab-pane>
          <el-tab-pane name="vehicle" label="库房销售排行"></el-tab-pane>
        </el-tabs>
        <div class="main-content">
          <el-card class="box-card-query" shadow="never">
            <el-descriptions size="mini" :column="12" :colon="false">
              <el-descriptions-item :span="9" :contentStyle="{ 'height': '40px', overflow: 'auto' }">
                <el-form :inline="true">
                  <el-form-item>
                    {{ queryFormat.beginDate }}
                    <span style="margin: 0 6px;">至</span>
                    {{ queryFormat.endDate }}
                  </el-form-item>
                  <el-form-item label="仓库:">
                    {{ inWarehouse.length ? inWarehouse : '全部' }}
                  </el-form-item>
                  <el-form-item label="业务员:">
                    {{ salesman.length ? salesman : '全部' }}
                  </el-form-item>
                </el-form>
              </el-descriptions-item>
              <el-descriptions-item :contentStyle="{ 'justify-content': 'flex-end' }">
                <div style="height: 40px; line-height: 40px;">

                  <el-button size="mini" type="success" @click="exportExcel">导出</el-button>
                </div>
              </el-descriptions-item>
            </el-descriptions>
          </el-card>
          <div class="table" v-loading="tableLoading">
            <customer ref="table" v-if="activeName == 'customer'" :table-data="tableData" :sum="sum"
              @get-table-data="load" @columns="getCustomColumns" @sort="sortChange" :visible.sync="dialogVisible" :transmitQuery="transmitQuery" @onSubmit="onSubmit">
            </customer>
            <salesman ref="table" v-if="activeName == 'salesman'" :table-data="tableData" :sum="sum"
              @get-table-data="load" @columns="getCustomColumns" @sort="sortChange" :visible.sync="dialogVisible" :transmitQuery="transmitQuery"  @onSubmit="onSubmit">
            </salesman>
            <commodity ref="table" v-if="activeName == 'commodity'" :table-data="tableData" :sum="sum"
              @get-table-data="load" @columns="getCustomColumns" @sort="sortChange" :visible.sync="dialogVisible" :transmitQuery="transmitQuery"  @onSubmit="onSubmit">
            </commodity>
            <vehicle ref="table" v-if="activeName == 'vehicle'" :table-data="tableData" :sum="sum" @get-table-data="load"
              @columns="getCustomColumns" @sort="sortChange" :visible.sync="dialogVisible" :transmitQuery="transmitQuery"  @onSubmit="onSubmit"></vehicle>
          </div>
        </div>
      </div>
    </el-main>
    <el-dialog title="自定义显示列" :visible.sync="dialogVisible" width="20%">
      <custom-columns ref="customColumns" v-if="dialogVisible" @confirm="dialogClose"></custom-columns>
    </el-dialog>
  </el-container>
</template>

<script>
import datePicker from '@/components/common/datePicker.vue'
import customer from '@/components/saleManage/ranking/customer.vue'
import salesman from '@/components/saleManage/ranking/salesman.vue'
import commodity from '@/components/saleManage/ranking/commodity.vue'
import vehicle from '@/components/saleManage/ranking/vehicle.vue'
import customColumns from '@/components/common/customColumns.vue'
import { pickerOptions, toRawType, debounce, getAddDate, getNowFormatDate, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
  name: "CustomerArrearPerOrder",
  components: {
    datePicker,
    customer,
    salesman,
    commodity,
    vehicle,
    customColumns
  },
  data() {
    let beginDate = getAddDate(-3)
    let endDate = getNowFormatDate()
    return {
      isCollapse: false,
      queryForm: {
        isContainBack: { submitName: 'isContainBack', selected: 'N' },
        label: { submitName: 'label', selected: [], list: [] },
        billDate: { submitName: 'billDate', selected: [beginDate, endDate] },
        domainDesc: { submitName: 'domainID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户大片区', request: { url: '/Account/domainDefine/getDomainListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        smallDomain: { submitName: 'smallDomainID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户小片区', request: { url: '/Account/domainDefine/getSmallDomainListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        customerTypes: { submitName: 'classifyID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户类型', request: { url: '/Account/customerTypeDefine/getCustomerTypesForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        customer: { submitName: 'customerID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        inWarehouse: { submitName: 'warehouseID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择仓库', request: { url: '/Account/wareHouseDefine/selectWarehouseForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        financialBrand: { submitName: 'itemBrandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isEnabled: 'Y' }, text: '', value: '' } },
        brand: { submitName: 'brandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择大类', request: { url: '/Account/dataSearch/selectBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
        brandType: { submitName: 'itemTypeID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: true, list: [], placeholder: '请选择小类', request: { url: '/Account/dataSearch/selectTypeListNewForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
        product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        salesman: { submitName: 'salesmanID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择业务员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
      },
      inWarehouse: [],
      salesman: [],
      queryFormat: {
        beginDate,
        endDate
      },
      pickerOptions: pickerOptions,
      activeName: 'customer',
      pagination: {
        billSearchType: 0,
        page: 0,
        size: 50,
        sortBy: '',
        sortField: ''
      },
      tableLoading: false,
      tableData: [],
      sum: {},
      dialogVisible: false,
      transmitQuery: {}
    }
  },
  created() {
    // this.load()
    this.getLabelData()
    this.onSubmit()
  },
  mounted() {
    window.top.addEventListener('message', this.messageOfSelect)
  },
  beforeDestroy() {
    window.top.removeEventListener('message', this.messageOfSelect)
  },
  methods: {
    async getLabelData() {
      const { data: res } = await this.$http.post('/Account/pubLabelDefineVue/selectLabelList.html', this.Qs.stringify({ labelType: '001' }))
      if (res.code != 'success') return this.$message.error(res.message)
      res.result = JSON.parse(res.result)
      this.queryForm.label.list = JSON.parse(res.result.data)
    },
    brandChange(val) {
      let str = val.map(item => "'" + item.value + "'").join(',')
      this.queryForm.brandType.request.params['brandID'] = str
      this.queryForm.brandType.isReSearch = true
    },
    load: debounce(async function () {
      // this.tableData = [ { name: '漳卅' } ]

      this.tableLoading = true
      let url = '/erpnew/account/c/reada46ceb/salRanking/selectCustomerSalRanking.html'
      let billSearchType = 0
      if (this.activeName == 'customer') {
        url = '/erpnew/account/c/reada46ceb/salRanking/selectCustomerSalRanking.html'
        billSearchType = 0
      } else if (this.activeName == 'salesman') {
        url = '/erpnew/account/c/reada46ceb/salRanking/selectSalesManSalRanking.html'
        billSearchType = 1
      } else if (this.activeName == 'commodity') {
        url = '/erpnew/account/c/reada46ceb/salRanking/selectItemSalRanking.html'
        billSearchType = 2
      } else if (this.activeName == 'vehicle') {
        url = '/erpnew/account/c/reada46ceb/salRanking/selectWarehouseSalRanking.html'
        billSearchType = 3
      }
      this.pagination.billSearchType = billSearchType
      this.pagination.page++
      const { data: res } = await this.$post(url, { ...this.queryFormat, ...this.pagination })
      this.tableLoading = false
      if (res.code == 0) {
        if (res.data) {
          this.tableData = this.tableData.concat(res.data.data)
          this.$refs['table'].$children[0].doLayout()
          if (res.data.sum) {
            this.sum = res.data.sum
          }
        }
      } else {
        // this.$confirm(res.message, '提示', {
        //   confirmButtonText: '确定',
        //   showCancelButton: false,
        //   type: 'error'
        // })
      }
    }, 100, true),
    customerInputFocus() {
      this.$refs['customerSelectRef'].blur()
      window.top.openDialog55('选择客户', '/Account/sys/common/customerSelect.html?isFitterEnabled=N&tag=SalesRankingCustomer')
    },
    productInputFocus() {
      this.$refs['productSelectRef'].blur()
      window.top.openDialog55('选择商品', '/Account/sys/common/productSelect.html?tag=SalesRankingProduct&isFitterEnabled=N')
    },
    // 接受子页面数据
    messageOfSelect(e) {
      let { data: res } = e
      if (res.tag == 'SalesRankingProduct') {
        if (res.code != 'success') return false
        // console.log(this.$refs['productSelectRef'])
        this.$set(this.queryForm.product, 'list', res.data)
        // this.queryForm.product.selected = res.data.map(item => (item.value))
        this.queryForm.product.selected = res.data
        top.layer.closeAll('iframe')
      } else if (res.tag == 'SalesRankingCustomer') {
        if (res.code != 'success') return false
        // console.log(this.$refs['productSelectRef'])
        this.$set(this.queryForm.customer, 'list', res.data)
        // this.queryForm.product.selected = res.data.map(item => (item.value))
        this.queryForm.customer.selected = res.data
        top.layer.closeAll('iframe')
      }
    },
    onSubmit() {
      this.transmitQuery = JSON.parse(JSON.stringify(this.queryForm))

      let tempItem = {}
      this.tableData = []
      this.pagination.page = 0
      Object.values(this.queryForm).forEach(item => {
        if (toRawType(item.selected) == 'Array') {
          if (item.submitName == 'billDate') {
            tempItem['beginDate'] = item.selected[0] || ''
            tempItem['endDate'] = item.selected[1] || ''
            return false
          }
          if (item.submitName == 'label') {
            tempItem[item.submitName] = item.selected.map(i => "'" + i.id + "'").join(',') || ''
            return false
          }
          tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
        } else if (toRawType(item.selected) == 'String') {
          // if (item.submitName == 'financialBrand') {
          //   tempItem[item.submitName + 'ID'] = '2010010101010000000'
          //   tempItem[item.submitName + 'Name'] = '综合品牌'
          //   return false
          // }
          tempItem[item.submitName] = item.selected || ''
        } else if (toRawType(item.selected) == 'Number') {
          tempItem[item.submitName] = item.selected || 0
        } else if (toRawType(item.selected) == 'Object') {
          // if (['account', 'financialBrand', 'customer'].includes(item.submitName)) {
          //   tempItem[item.submitName + 'ID'] = item.selected.value || ''
          //   tempItem[item.submitName + 'Name'] = item.selected.text || ''
          //   return false
          // }
          // if (item.submitName == 'sort') {
          //   tempItem['sortField'] = item.selected.sortField || ''
          //   tempItem['softBy'] = item.selected.softBy || ''
          //   return false
          // }
          tempItem[item.submitName] = item.selected.value || ''
        }
      })
      this.queryFormat = tempItem
      this.inWarehouse = [...this.queryForm.inWarehouse.selected.map(i => i.text)]
      this.salesman = [...this.queryForm.salesman.selected.map(i => i.text)]
      this.$nextTick(() => {
        this.load()
      })
      console.log(tempItem)
    },
    onReset() {
      this.$refs['queryFormRef'].resetFields()
      this.onSubmit()
    },
    handleClick() {
      this.$nextTick(() => {
        this.onSubmit()
      })
    },
    sortChange({ prop, order }) {
      if (order == 'ascending') {
        order = 'ASC'
      } else if (order == 'descending') {
        order = 'DESC'
      }
      this.pagination.sortField = prop
      this.pagination.sortBy = order
      this.pagination.page = 0
      this.onSubmit()
    },
    getCustomColumns(customColumn) {
      this.dialogVisible = true
    //   let tempArr = [...customColumn]
      let tempArr = JSON.parse(JSON.stringify(customColumn))
      this.$nextTick(() => {
        let element = this.$refs['customColumns']
        element.loading = false
        element.setCustomcolumns(tempArr)
      })
    },
    exportExcel() {
      let table = this.$refs['table']
      let tempArr = table.$children[0].$children.map(item => {
        return {
          label: item.label,
          prop: item.prop,
          index: item.index
        }
      // }).filter(item => (item.prop || Array.isArray(item))).flat()
      }).filter(item => (item.prop || Array.isArray(item))).flat().sort((a, b) => { return a.index - b.index })
      let params = { ...this.queryFormat, ...this.pagination }
      params.billSearchType = this.pagination.billSearchType
      exportExcelCommonForVue(params, tempArr, '/erpnew/account/c/reada46ceb/salRanking/salExport.html')
      console.log(params, tempArr)
    },
    dialogClose(isSubmit) {
        if(!isSubmit){
            this.dialogVisible = false
            return
        }
      let funcCode = 216
      if (this.activeName == 'customer') {
        funcCode = 216
      } else if (this.activeName == 'salesman') {
        funcCode = 218
      } else if (this.activeName == 'commodity') {
        funcCode = 217
      } else if (this.activeName == 'vehicle') {
        funcCode = 219
      }
      let $customColumns = this.$refs['customColumns']
      $customColumns.$nextTick(async () => {
        let { customColumns } = $customColumns
        const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
          funcCode,
          customSetInfo: JSON.stringify(customColumns)
        }))
        if (res.code != 'success') return this.$message.error(res.message)
        this.$message.success(res.message)
        this.dialogVisible = false
        this.$refs['table'].getCustomColumnsList()
      })
      this.$nextTick(() => {
        this.$refs["table"].$children[0].doLayout();
      })
    }
  }
};
</script>
<style scoped lang="less">
#tab {
  height: calc(100vh - 20px);

  .box-card {
    height: calc(100% - 2px);

    ::v-deep .el-card__header {
      padding: 8px 20px;
      height: 33px;
      background-color: #F5F7FA;
      color: #409EFF;
    }

    ::v-deep .el-card__body {
      padding: 6px;
      height: calc(100% - 33px);
      box-sizing: border-box;
    }
  }

  .el-aside {
    ::v-deep .el-card__body {
      .el-form {
        height: calc(100% - 70px);

        .el-scrollbar {
          height: 100%;
        }

        .el-form-item {
          margin: 18px 0 0;
          position: relative;

          .el-form-item__label {
            position: absolute;
            z-index: 2;
            top: -12px;
            margin-left: 10px;
            padding: 0 6px;
            line-height: normal;
            background-color: #fff;
          }
        }
      }

      .calculation-form {
        .el-form-item {
          text-align: center;

          .el-form-item__label {
            margin: 0;
            left: 36px;
          }

          .input-with-select {
            .el-input-group__prepend {
              padding: 0 12px;
              background-color: #fff;

              .select-multiple {
                display: inline-block;
                width: 50px;
              }
            }
          }

          .el-input-number .el-input__inner {
            text-align: left;
          }
        }
      }
    }

    .is-collapse {
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      border: 1px #DCDFE6 solid;
      cursor: pointer;
      background-color: rgba(83, 168, 255, 0.1);
      color: #409EFF;
    }

    .select_multiple {
      ::v-deep .el-select__tags {
        max-height: 80px;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
  }

  .el-main {
    padding: 0 6px 0;

    .main-wrap {
      height: calc(100% - 2px);
      border: 1px solid #DCDFE6;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }

    ::v-deep .el-tabs {
      box-shadow: none;
      border: none;

      .el-tabs__item {
        height: 33px;
        line-height: 33px;
      }

      .el-tabs__content {
        height: 0;
        padding: 0;
      }
    }

    .main-content {
      padding: 15px;
      box-sizing: border-box;
      height: calc(100% - 32px);
      // display: flex;
      // flex-flow: column;
    }

    ::v-deep .box-card-query {
      flex-shrink: 0;

      .el-card__body {
        padding: 12px 20px;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 0;
      }
    }
  }

  .table {
    height: calc(100% - 74px);

    // flex: 1;
    ::v-deep .el-table {

      th,
      td {
        padding: 6px 0;

        .cell {
          font-size: 14px;
          // padding: 0;
        }
      }
    }
    ::v-deep .el-table--scrollable-x .el-table__body-wrapper {
        z-index: 2;
    }
  }

  ::v-deep .el-dialog {
    // max-height: 70vh;
    // min-width: 800px;

    // .el-dialog__body {
    //   height: calc(100% - 54px);
    // //   padding-top: 0;
    //   box-sizing: border-box;
    //   display: flex;
    //   flex-flow: column;

    //   .table {
    //     height: calc(100% - 48px);
    //   }

    //   .box-card-query {
    //     .el-card__body {
    //       padding: 6px;
    //     }

    //     .el-form {
    //       .el-form-item {
    //         margin-bottom: 0;
    //       }
    //     }
    //   }
    // }
  }

  .border {
    border-top: 1px #E4E7ED solid;
  }

  .cell-p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.bill-detail-dialog {
  ::v-deep .el-dialog__header {
    padding: 0;
  }

  ::v-deep .el-dialog__body {
    padding: 20px;
    height: 500px;
  }

  ::v-deep .el-dialog {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
